export default {
    USER(state, items) {
        state.items = items
    }
}